import { Box } from "@mui/material";
import { Marker } from "@vis.gl/react-google-maps";

import { UtfMap } from "../../GoogleMap/UtfMap";
import { extractLatLng } from "../../GoogleMap/utils";
import type { AddressEntry } from "./types";

type PropertiesMapProps = Readonly<{
  addresses: AddressEntry[];
  mapCenter?: { lat: number; lng: number };
  mapId?: string;
  mapKey?: string;
  defaultZoom?: number;
  height?: string | number;
  onMarkerClick?: (substationUid: string) => void;
  markerLabel?: (substationUid: string) => string;
}>;

export function PropertiesMap({
  addresses,
  mapCenter,
  mapId = "properties-map",
  mapKey,
  defaultZoom = 8,
  height = "220px",
  onMarkerClick,
  markerLabel,
}: PropertiesMapProps) {
  return (
    <Box sx={{ height, width: "100%" }}>
      <UtfMap id={mapId} key={mapKey} defaultZoom={defaultZoom} center={mapCenter}>
        {addresses?.map((item) => {
          const [lat, lng] = extractLatLng(item);
          if (lat === null || lng === null) return null;

          const substationUid = (item?.substation_uid ?? "") as string;

          return (
            <Marker
              key={substationUid}
              position={{ lat, lng }}
              title={markerLabel ? markerLabel(substationUid) : undefined}
              onClick={onMarkerClick ? () => onMarkerClick(substationUid) : undefined}
            />
          );
        })}
      </UtfMap>
    </Box>
  );
}
